const PagesToBeExempt=[
  '/Login'
 ]

export default PagesToBeExempt;